var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4426 6.21575C16.7698 6.21575 16.2243 5.67 16.2243 4.99725V1.25H5.02831C4.35556 1.25 3.81006 1.7955 3.81006 2.4685V22.5315C3.81006 23.2043 4.35556 23.75 5.02831 23.75H19.9711C20.6438 23.75 21.1898 23.2043 21.1898 22.5315V6.21575H17.4426Z",
    fill: "#8DC63F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4426 6.21575H21.1901L16.2241 1.25V4.99725C16.2241 5.67025 16.7696 6.21575 17.4426 6.21575Z",
    fill: "#8DC63F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M17.4425 6.21575H21.19L16.224 1.25V4.99725C16.224 5.67025 16.7695 6.21575 17.4425 6.21575Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17273 14.7638C6.84493 14.7638 6.61633 14.9986 6.61633 15.3384C6.61633 15.6662 6.84493 15.9071 7.16037 15.9071H7.16689C7.50052 15.9071 7.7226 15.6662 7.7226 15.3384C7.71643 14.9924 7.49366 14.7638 7.17273 14.7638Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6043 11.6736H10.5289L10.1767 12.4339C10.0717 12.6748 9.99139 12.8602 9.8922 13.1262H9.87984C9.78099 12.8914 9.68797 12.6875 9.56474 12.4339L9.19988 11.6736H8.11832L9.28054 13.7317L8.07507 15.8392H9.15045L9.49026 15.0851C9.62618 14.7947 9.73122 14.5784 9.81806 14.3375H9.83007C9.94746 14.5784 10.0467 14.7947 10.2008 15.0851L10.578 15.8392H11.6657L10.4294 13.707L11.6043 11.6736Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1785 11.6736H12.239V15.8388H14.8346V15.048H13.1785V11.6736Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0708 13.3667C16.5271 13.1567 16.2985 13.0393 16.2985 12.7733C16.2985 12.5632 16.4962 12.3713 16.904 12.3713C17.3056 12.3713 17.6087 12.4891 17.7693 12.569L17.979 11.8153C17.7319 11.6979 17.3921 11.6052 16.916 11.6052C15.9395 11.6052 15.3402 12.1427 15.3402 12.8533C15.3402 13.4653 15.7974 13.8483 16.4897 14.0954C16.9901 14.2688 17.1878 14.4232 17.1878 14.6766C17.1878 14.9549 16.9592 15.1338 16.5268 15.1338C16.1248 15.1338 15.7294 15.004 15.4823 14.8743L15.2904 15.6466C15.5252 15.7766 15.9951 15.9064 16.4708 15.9064C17.6138 15.9064 18.1455 15.3129 18.1455 14.6148C18.1458 14.022 17.806 13.6386 17.0708 13.3667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileLogo);
export default __webpack_public_path__ + "static/media/file-logo.688f46f4bbc2bc2ebc7e5bbe86448cec.svg";
export { ForwardRef as ReactComponent };